import {h, Component} from 'preact';
import {connect} from 'preact-redux';
import style from './style.scss';
import Input from '/chat/src/components/Forms/Input';
//import ConversationClass from '/chat/src/lib/Conversation';
import SystemModel from '/chat/src/redux/model/system/model';
import CustomizationModel from '/chat/src/redux/model/customization/model';
import {TicketModel} from '/chat/src/redux/model'
import UserModel from '/chat/src/redux/model/user/model';

import UserImage from '/chat/src/components/SVGImages/User'
import SaveImage from '/chat/src/components/SVGImages/Save'
import CancelImage from '/chat/src/components/SVGImages/Cancel'

class SettingsBody extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: props.user.email,
            name: props.user.name,
            phone: props.user.phone,
        }
        this.renderForm = this.renderForm.bind(this)
        this.handleSave = this.handleSave.bind(this)
    }

    handleSave(){
        this.props.dispatch(UserModel.update({
            'email': this.state.email,
            'name': this.state.name,
            'phone': this.state.phone,
        }))
    }
    renderForm(form){
        const obj = this.state[form]
        return (
            <div style={{position: 'relative', width: '70%', margin: 'auto', marginBottom: '10px'}}>
                <Input label={form} value={obj}
                    onChange={newValue=>{
                        this.setState({[form]: newValue})
                    }}
                 />
            </div>
        )
    }

    render() {
        const language = this.props.language;
        /*
        <div className={style.Button} onClick={()=>{
    this.setState({'email': '', 'name': '', 'phone': ''})
}}>
    <CancelImage color='black' size='16'/>
    <span style={{marginLeft: '10px'}}>
        Rensa alla fält
    </span>

</div>
        */
        return (
            <div
                className={style.Body}
            >
                <div className={style.Component}
                    style={{
                        fontSize: '20px',
                        fontWeight: '300'
                    }}

                >
                    <UserImage color='black' size='20'/>
                    <span style={{marginLeft: '10px'}}>
                         {language.get('UserInfo')}
                    </span>
                </div>
                <form>
                    {this.renderForm('email', language.get('Email'))}
                    {this.renderForm('name', language.get('Name'))}
                    {this.renderForm('phone', language.get('Phone'))}
                </form>

                <div className={style.Button + ' '+style.Rounded} onClick={this.handleSave}>
                    <SaveImage color='black' size='16'/>
                    <span style={{marginLeft: '10px'}}>
                        {language.get('Save')}
                    </span>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state){
    const color = CustomizationModel.getColor(state)
    const language = CustomizationModel.getLanguage(state)
    const conversations = TicketModel.getAll(state)
    return {
        language: language,
        user: UserModel.get(state).toJS()
    };
}

export default connect(mapStateToProps)(SettingsBody);



// WEBPACK FOOTER //
// ./routes/Settings/Body.js